<!--
  `app-label` can only be projected into one `ng-content`, so the floating and
  the static label share this point and are mutually exclusive.
-->
<ng-template #labelContent>
  <ng-content select="app-label"></ng-content>
  <span
    class="app-placeholder-required app-form-field-required-marker"
    aria-hidden="true"
    *ngIf="!hideRequiredMarker && _control.required && !_control.disabled"
  >
    &#32;*
  </span>
</ng-template>

<div class="app-form-field-wrapper">
  <!--
    Carries its own class so none of the floating-label positioning rules
    (which are keyed to .app-form-field-label) reach it.
  -->
  <label
    class="app-form-field-static-label"
    [id]="_labelId"
    [attr.for]="_control.id"
    [class.app-accent]="color === 'accent'"
    [class.app-warn]="color === 'warn'"
    *ngIf="_hasStaticLabel()"
  >
    <ng-container *ngTemplateOutlet="labelContent"></ng-container>
  </label>
  <div
    class="app-form-field-flex"
    #connectionContainer
    (click)="_control.onContainerClick($event)"
  >
    <ng-container *ngIf="appearance === 'outline'">
      <div class="app-form-field-outline">
        <div class="app-form-field-outline-start"></div>
        <div class="app-form-field-outline-gap"></div>
        <div class="app-form-field-outline-end"></div>
      </div>
      <div class="app-form-field-outline app-form-field-outline-thick">
        <div class="app-form-field-outline-start"></div>
        <div class="app-form-field-outline-gap"></div>
        <div class="app-form-field-outline-end"></div>
      </div>
    </ng-container>

    <div
      class="app-form-field-prefix"
      *ngIf="_prefixChildren.length"
      (cdkObserveContent)="updateOutlineGap()"
      [cdkObserveContentDisabled]="appearance !== 'outline'"
    >
      <ng-content select="[appPrefix], [appIconPrefix]"></ng-content>
    </div>

    <div class="app-form-field-infix">
      <ng-content></ng-content>

      <span class="app-form-field-label-wrapper">
        <!-- aria-owns: JAWS/NVDA otherwise skip a label that precedes the control. -->
        <label
          class="app-form-field-label"
          (cdkObserveContent)="updateOutlineGap()"
          [cdkObserveContentDisabled]="appearance !== 'outline'"
          [id]="_labelId"
          [attr.for]="_control.id"
          [attr.aria-owns]="_control.id"
          [class.app-form-field-empty]="_control.empty && !_shouldAlwaysFloat()"
          [class.app-accent]="color === 'accent'"
          [class.app-warn]="color === 'warn'"
          #label
          *ngIf="_hasFloatingLabel()"
        >
          <ng-container *ngTemplateOutlet="labelContent"></ng-container>
        </label>
      </span>
    </div>

    <div class="app-form-field-suffix" *ngIf="_suffixChildren.length">
      <ng-content select="[appSuffix], [appIconSuffix]"></ng-content>
    </div>
  </div>

  <div class="app-form-field-underline" *ngIf="appearance !== 'outline'">
    <span
      class="app-form-field-ripple"
      [class.app-accent]="color === 'accent'"
      [class.app-warn]="color === 'warn'"
    ></span>
  </div>

  <div
    class="app-form-field-subscript-wrapper"
    [ngSwitch]="_getDisplayedMessages()"
  >
    <div
      *ngSwitchCase="'error'"
      [@transitionMessages]="_subscriptAnimationState"
    >
      <ng-content select="app-error"></ng-content>
    </div>

    <div
      class="app-form-field-hint-wrapper"
      *ngSwitchCase="'hint'"
      [@transitionMessages]="_subscriptAnimationState"
    >
      <ng-content select="app-hint:not([align='end'])"></ng-content>
      <div class="app-form-field-hint-spacer"></div>
      <ng-content select="app-hint[align='end']"></ng-content>
    </div>
  </div>
</div>
